import React from 'react';
import FileDownload from 'react-file-download';
import irelandApi from '../irelandApi';
import * as moment from 'moment';
import { actions } from 'react-redux-form';
import store, { history } from '../store';
import { toast } from 'react-toastify';
import ToastMessage from '../components/common/toast-message';


export const getStockItIncentivesOutlets = () => (dispatch) => {
  dispatch({
    type: 'GET_STOCK_IT_ELIGIBLE_OUTLETS_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/stock_it_incentive_eligible_outlets', {})
    .then(response => {
      dispatch({
        type: 'GET_STOCK_IT_ELIGIBLE_OUTLETS_FULFILLED',
        payLoad: response.data
      });
      return Promise.resolve(response.data);
    })
    .catch(error => {
      dispatch({
        type: 'GET_STOCK_IT_ELIGIBLE_OUTLETS_REJECTED',
        payLoad: error
      });
      return Promise.reject(error);
    });
};

export const getStockItIncentivesOutletVisitData = (id) => (dispatch) => {
  dispatch({
    type: 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_PENDING',
    payLoad: []
  });

  return irelandApi
    .get(`/api/stock_it_incentives_outlets_visit_data/${id}`)
    .then((response) => {
      dispatch({
        type: 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_FULFILLED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_INCENTIVES_OUTLET_VISIT_DATA_REJECT',
        payLoad: error
      });

      return Promise.reject(error);
    });
};

export const getStockItIncentivesOutletsVisitData = () => (dispatch) => {
  dispatch({
    type: 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA_PENDING',
    payLoad: []
  });

  return irelandApi
    .get('/api/stock_it_incentives_outlets_visit_data', {})
    .then((response) => {
      dispatch({
        type: 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_INCENTIVES_OUTLETS_VISIT_DATA_REJECT',
        payLoad: error
      });

      return Promise.reject(error);
    });
};

const prepareStockItIncentiveFormData = (payLoad) => {
  let formData = new FormData();

  Object.keys(payLoad).forEach(key => {
    if (key === 'product_ids' || key === 'group_ids') {
      payLoad[key].forEach(id => formData.append(`stock_it_incentive[${key}][]`, id))
    } else {
      formData.append(`stock_it_incentive[${key}]`, payLoad[key])
    }
  });

  return formData;
};

export const saveStockItIncentive = (data) => (dispatch) => {
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };

  let newIncentive = Object.assign({}, data);
  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD")
  };

  if (newIncentive["start_date"]) {
    newIncentive["start_date"] = formatDate(newIncentive["start_date"]);
  }
  if (newIncentive["end_date"]) {
    newIncentive["end_date"] = formatDate(newIncentive["end_date"]);
  }

  newIncentive["product_ids"] = newIncentive["product_ids"].map(curr => {
    return curr.value;
  });

  newIncentive["group_ids"] = newIncentive["group_ids"].map(curr => {
    return curr.value;
  });

  if (newIncentive["group_ids"].indexOf("all") > -1) {
    newIncentive["all_groups"] = true;
    delete newIncentive["group_ids"];
  }

  const formData = prepareStockItIncentiveFormData(newIncentive);

  dispatch({type: "ADD_STOCK_IT_INCENTIVES_PENDING"});
  return irelandApi.post('/api/admin/stock_it_incentives', formData, config)
    .then((response) => {
      dispatch({
        type: "ADD_STOCK_IT_INCENTIVES_FULFILLED",
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Stock It Incentive created successfully"/>);
      history.push('/admin/stock_it_incentives');
      dispatch(actions.reset('deep.stock_it_incentives'));
    })
    .catch((error) => {
      dispatch({
        type: 'ADD_STOCK_IT_INCENTIVES_REJECTED',
        payload: error.response.data
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during create Stock It Incentive"/>);
    })
};


export const updateStockItIncentive = (id, data) => (dispatch) => {
  let newIncentive = Object.assign({}, data);

  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD")
  };

  if (newIncentive["start_date"]) {
    newIncentive["start_date"] = formatDate(newIncentive["start_date"]);
  }
  if (newIncentive["end_date"]) {
    newIncentive["end_date"] = formatDate(newIncentive["end_date"]);
  }

  newIncentive["product_ids"] = newIncentive["product_ids"].map(curr => {
    return curr.value;
  });

  newIncentive["group_ids"] = newIncentive["group_ids"].map(curr => {
    return curr.value;
  });

  if (newIncentive["group_ids"].indexOf("all") > -1) {
    newIncentive["all_groups"] = true;
    delete newIncentive["group_ids"];
  }
  const formData = prepareStockItIncentiveFormData(newIncentive);

  dispatch({type: "UPDATE_STOCK_IT_INCENTIVES_PENDING"});
  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.patch(`/api/admin/stock_it_incentives/${id}`, formData, config)
    .then((response) => {
      dispatch({
        type: "UPDATE_STOCK_IT_INCENTIVES_FULFILLED",
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Stock It Incentive updated successfully"/>);
      history.push('/admin/stock_it_incentives');
    })
    .catch((error) => {
      dispatch({
        type: 'UPDATE_STOCK_IT_INCENTIVES_REJECTED',
        payLoad: error.data
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during update stock it incentive"/>);
      return Promise.reject(error.response.data);
    })
};

export const getStockItIncentives = (page = 1) => (dispatch) => {
  dispatch({type: "GET_STOCK_IT_INCENTIVES_PENDING", payload: []});
  return irelandApi.get('/api/admin/stock_it_incentives', {params: {page: page}})
    .then((response) => {
      dispatch({type: "GET_STOCK_IT_INCENTIVES_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_STOCK_IT_INCENTIVES_REJECTED', payLoad: error.data});
      console.log(error)
      return Promise.reject(error.response.data);
    })
};

export const getStockItIncentive = (id) => (dispatch) => {
  dispatch({type: "GET_STOCK_IT_INCENTIVE_PENDING", payload: []});
  const url = `/api/admin/stock_it_incentives/${id ? id : 'new'}`;
  return irelandApi
    .get(url)
    .then((response) => {
      const createProductList = (products) => {
        return products.map((curr) => {
          return {
            label: `${curr.sku_name} ${curr.sku_code}`,
            value: curr.id
          }
        });
      };
      const createGroupList = (groups) => {
        return attributes['all-groups'] ?
          [{label: 'All', value: 'all'}] :
          groups.map((curr) => {
            return {
              label: `${curr.name}`,
              value: curr.id
            }
          });
      };
      const data = response.data.data;
      const attributes = data ? data.attributes : {};

      if (id) {
        dispatch(actions.load('deep.stock_it_incentives', {
          "name": attributes['name'],
          "start_date": attributes['start-date'],
          "end_date": attributes['end-date'],
          "display_to_date": attributes['display-to-date'],
          "display_from_date": attributes['display-from-date'],
          "max_points": attributes['max-points'],
          "blu": attributes['blu'],
          "blu_quantity": attributes['blu-quantity'],
          "start_date_before_current_date": attributes['start-date-before-current-date'],
          "product_ids": createProductList(attributes['products']),
          "group_ids": createGroupList(attributes['groups']),
          "target": attributes['target']
        }));
        store.dispatch(actions.resetValidity('deep.stock_it_incentives'));
      } else {
        dispatch(actions.load('deep.stock_it_incentives', {
          "name": '',
          "start_date": '',
          "end_date": '',
          "display_to_date": '',
          "display_from_date": '',
          "max_points": null,
          "blu": false,
          "blu_quantity": null,
          "product_ids": '',
          "group_ids": '',
          "target": ''
        }));

      }
      dispatch({
        type: "GET_STOCK_IT_INCENTIVE_FULFILLED",
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_STOCK_IT_INCENTIVE_REJECTED',
        payLoad: error.response
      });
      return Promise.reject(error.response.data.errors);
    })
};

export const downloadCsv = (id) => (dispatch) =>
  irelandApi.get(`/api/admin/stock_it_incentives/${id}/download`, { headers: { 'Accept': 'text/csv' } })
            .then((response) => {
              console.log(response);
              FileDownload(response.data, 'stock_it_reward.csv')
            })
            .catch((error) => {
              toast.error(<ToastMessage iconStyle="error" message={'Stock it reward csv can not be downloaded.'}/>);
            });



// WEBPACK FOOTER //
// ./src/actions/stock-it-incentives.js